import React from 'react';

import { IconProps, StyledPath, StyledStrokedGroup, StyledSvg } from '../iconCommons';

export const IconPiggyBank = ({ color = 'currentColor', size = 'small', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none" size={size} {...props}>
        <StyledStrokedGroup color={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
            <StyledPath
                d="M31 14a4 4 0 0 1-4 4M8 9.067A11.09 11.09 0 0 0 3.467 15H1v8h3.32A11.29 11.29 0 0 0 7 26.163V30a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1.655c2.595.868 5.402.873 8 .015V30a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3.817A10.589 10.589 0 0 0 27 18a10.737 10.737 0 0 0-5.01-8.941"
                color="none"
            />
            <StyledPath d="M11 10a9.017 9.017 0 0 1 8 0" color="none" />
            <StyledPath d="M11 5a4 4 0 1 0 8 0 4 4 0 0 0-8 0v0Z" color="none" />
        </StyledStrokedGroup>
    </StyledSvg>
);
